export default __webpack_public_path__ + "static/media/snail.bce85db8.svg";